import React from "react";

export const BackIcon = (props: any) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.7591 7.0955C2.77741 7.19005 2.82317 7.28033 2.89639 7.35355L8.39639 12.8536C8.59166 13.0488 8.90824 13.0488 9.1035 12.8536C9.29876 12.6583 9.29876 12.3417 9.1035 12.1464L3.95705 7L9.1035 1.85355C9.29876 1.65829 9.29876 1.34171 9.1035 1.14645C8.90824 0.951184 8.59166 0.951184 8.39639 1.14645L2.8969 6.64594C2.77486 6.76798 2.72859 6.93792 2.7591 7.0955Z"
      fill="#73828C"
    />
  </svg>
);
